<template>
  <div
    class="relative flex flex-col min-w-0 break-words w-full mb-6 border border-blueGray-200 rounded-lg bg-white"
  >
    <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
      <h6 class="uppercase text-blueGray-400 mb-1 text-xs">
        Overview
      </h6>
      <h2 class="text-blueGray-700 text-lg">
        <i class="pi pi-exclamation-circle"></i> Needs Attention
      </h2>
    </div>
    <div class="px-4 pb-2 flex-auto">
      <div v-if="items.length === 0" class="text-xs text-blueGray-400 text-center py-8">
        Nothing needs your attention right now.
      </div>
      <router-link
        v-for="(item, i) in items"
        :key="i"
        :to="item.route"
        class="flex items-center justify-between py-3"
        :class="{'border-b border-blueGray-100': i < items.length - 1}"
      >
        <div class="flex items-center">
          <div
            class="text-white p-2 text-center inline-flex items-center justify-center w-8 h-8 rounded-lg mr-3"
            :class="item.count > 0 ? 'bg-orange-500' : 'bg-blueGray-300'"
          >
            <i :class="item.icon" style="font-size: 12px;"></i>
          </div>
          <span class="text-sm text-blueGray-600">{{ item.label }}</span>
        </div>
        <span class="text-sm font-semibold" :class="item.count > 0 ? 'text-orange-500' : 'text-blueGray-400'">
          {{ item.count }}
        </span>
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    // [{ label, count, icon, route }]
    items: {
      type: Array,
      default: () => []
    }
  }
}
</script>
